import React, { type ReactNode, useId } from "react";
import styles from "./CheckboxRenderer.module.scss";

interface ICheckboxRendererProps {
  isChecked: boolean;
  textContent: ReactNode;
  nestedContent?: ReactNode;
}

export interface ICheckboxChild {
  type: string;
  props?: Record<string, unknown>;
}

export interface ICheckboxData {
  isChecked: boolean;
  textContent: React.ReactNode[];
  nestedContent?: React.ReactNode[];
}

export function CheckboxRenderer({ isChecked, textContent, nestedContent }: ICheckboxRendererProps): ReactNode {
  const hasNested = React.Children.count(nestedContent) > 0;
  const labelId = useId();

  return (
    <li className={`${styles.checkboxOnly} ${isChecked ? styles.checked : ''}`}>
      <div className={styles.checkboxRow}>
        <input
          className={`${styles.customCheckbox} ${isChecked ? styles.checked : ''}`}
          type="checkbox"
          aria-checked={isChecked}
          checked={isChecked}
          disabled
          aria-labelledby={labelId}
        />
        <span id={labelId} className={styles.checkboxLabel}>
          {textContent}
        </span>
      </div>
      {hasNested && <div className={styles.nestedList}>{nestedContent}</div>}
    </li>
  );
}
